import Component from '../../shared/component';

export default class MoreMentorsButton extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.MoreMentorsButton', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.MoreMentorsButton', this.handleClick);
  }

  handleClick() {
    const csrfToken = $('meta[name="csrf-token"]').attr('content');
    $.ajaxSetup({
      beforeSend(xhr) {
        xhr.setRequestHeader('Csrf-Token', csrfToken);
      },
    });
    $.post('/accueil/track_more_mentors_event');
  }
}
